function compute(value) {
  return value.cardinalDirection.toLowerCase() === 's' ||
    value.cardinalDirection.toLowerCase() === 'w'
    ? -(+value.degrees + value.minutes / 60)
    : +value.degrees + value.minutes / 60
}

export function ddmToLatLng(coordinate) {
  const cardinalDirections = coordinate.replace(/[^a-zA-Z]+/g, '').split('')
  const coordinateNumbers = coordinate
    .replace(/[^0-9-.]+/g, ' ')
    .split(' ')
    .filter((v) => v !== '')

  if (coordinateNumbers.length !== 4 || coordinateNumbers.find((number) => isNaN(number))) {
    return null
  }

  const latitude = {
    degrees: coordinateNumbers[0],
    minutes: coordinateNumbers[1],
    cardinalDirection: cardinalDirections[0],
  }

  const longitude = {
    degrees: coordinateNumbers[2],
    minutes: coordinateNumbers[3],
    cardinalDirection: cardinalDirections[1],
  }

  return [compute(latitude), compute(longitude)]
}
